document.addEventListener('DOMContentLoaded', () => {
  if (document.documentElement.lang !== 'en') return;
  initTranslations();  
});

async function initTranslations() {
  try {
    const translations = await getTranslations(); // version-aware
    const reverseMap = buildReverseMap(translations);

    // Initial pass
    translateBoostFiltersSectionTitle(reverseMap);
    translateBoostFilters(reverseMap);
    translateBoostRefineByOption(reverseMap);
    translateBoostRefineByValue(reverseMap);
    translateBoostMobileToolbar(reverseMap);

    // React to Boost re-renders
    observeBoostFilters(reverseMap);

  } catch (err) {
    console.error('Translation init failed:', err);
  }
}

async function getTranslations() {
  const response = await fetch('/pages/translations');
  if (!response.ok) throw new Error(`HTTP ${response.status}`);

  const data = await response.json();
  const { version, translations } = data;

  const cacheKey = getCacheKey(version);

  // If cached for this version → use it
  const cached = sessionStorage.getItem(cacheKey);
  if (cached) {
    return JSON.parse(cached);
  }

  // Otherwise update cache
  clearOldTranslationCaches();
  sessionStorage.setItem(cacheKey, JSON.stringify(translations));

  return translations;
}

function getCacheKey(version) {
  return `translations_en_${version}`;
}

function clearOldTranslationCaches() {
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith('translations_en_')) {
      sessionStorage.removeItem(key);
    }
  });
}

function buildReverseMap(translations, from = 'fr', to = 'en') {
  const map = {};

  function walk(obj) {
    Object.values(obj).forEach(value => {
      if (
        value &&
        typeof value === 'object' &&
        value[from] &&
        value[to]
      ) {
        map[value[from].trim()] = value[to];
      } else if (value && typeof value === 'object') {
        walk(value);
      }
    });
  }

  walk(translations);

  return map;
}

function translateBoostFiltersSectionTitle(reverseMap) {
  document
    .querySelectorAll('.boost-sd__filter-option-title')
    .forEach(button => {
      if (button.dataset.translated) return;

      // Find the first text node
      const textNode = [...button.childNodes].find(
        node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
      );

      if (!textNode) return;

      const frText = textNode.textContent.trim();

      if (reverseMap[frText]) {
        textNode.textContent = reverseMap[frText] + ' ';
        button.dataset.translated = 'true';
      }

      const aria = button.getAttribute('aria-label');

      if (aria) {
        const translated = aria.replace(frText, reverseMap[frText]);
        button.setAttribute('aria-label', translated);
      }
    });
}

function translateBoostMobileToolbar(reverseMap) {
  const el = document.querySelector(
    '.boost-sd__filter-tree-vertical-toolbar-middle'
  );

  if (!el) return;

  const rawText = el.textContent.trim();

  // Reset flag if Boost changed content
  if (el.dataset.lastValue !== rawText) {
    delete el.dataset.translated;
  }

  if (el.dataset.translated) return;

  if (reverseMap[rawText]) {
    el.textContent = reverseMap[rawText];
    el.dataset.translated = 'true';
  }

  el.dataset.lastValue = el.textContent.trim();
}

function translateBoostRefineByOption(reverseMap) {
  document
    .querySelectorAll('.boost-sd__refine-by-vertical-refine-by-option')
    .forEach(label => {
      if (label.dataset.translated) return;

      // Example: "Catégorie:" or "Prix ($):"
      const rawText = label.textContent.trim();

      // Extract base label (remove colon + anything after)
      const baseText = rawText.replace(/\s*\(.*?\)\s*:|\s*:/, '').trim();

      if (reverseMap[baseText]) {
        const suffix = rawText.replace(baseText, '');
        label.textContent = reverseMap[baseText] + suffix;
        label.dataset.translated = 'true';
      }
    });
}

function translateBoostRefineByValue(reverseMap) {
  document
    .querySelectorAll('.boost-sd__refine-by-vertical-refine-by-value')
    .forEach(label => {
      if (label.dataset.translated) return;

      // Example: "Catégorie:" or "Prix ($):"
      const rawText = label.textContent.trim();

      // Extract base label (remove colon + anything after)
      const baseText = rawText.replace(/\s*\(.*?\)\s*:|\s*:/, '').trim();

      if (reverseMap[baseText]) {
        const suffix = rawText.replace(baseText, '');
        label.textContent = reverseMap[baseText] + suffix;
        label.dataset.translated = 'true';
      }
    });
}

function translateBoostFilters(reverseMap) {
  document
    .querySelectorAll('.boost-sd__filter-option-item-label')
    .forEach(label => {
      const text = label.textContent.trim();

      if (reverseMap[text]) {
        label.textContent = reverseMap[text];
      }
    });
}

function observeBoostFilters(reverseMap) {
  const observer = new MutationObserver(() => {
    translateBoostFiltersSectionTitle(reverseMap);
    translateBoostFilters(reverseMap);
    translateBoostRefineByOption(reverseMap);
    translateBoostRefineByValue(reverseMap);
    translateBoostMobileToolbar(reverseMap);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

//--------------------------
